import { BulkImportStatus } from '@dr-customer-offers-ui/lib-interfaces';

export const BULK_IMPORT_POLL_INITIAL_DELAY_MS = 2000;
export const BULK_IMPORT_POLL_INTERVAL_MS = 3000;
export const BULK_IMPORT_POLL_TIMEOUT_MS = 5 * 60 * 1000;

export const BULK_IMPORT_TERMINAL_STATUSES: ReadonlySet<BulkImportStatus> = new Set([
  BulkImportStatus.Succeeded,
  BulkImportStatus.Failed,
  BulkImportStatus.Partial,
  BulkImportStatus.Cancelled
]);